import { UnitOfMeasureTypes } from '../enumerations/unit-of-measure-type';
import { LOCAL_ISO_CURRENCY_CODE } from './localized-description-helper';

// Todo currenyCode should from POS config for localization
export function convertCurrency(
  amount: number,
  currencyCode: string = LOCAL_ISO_CURRENCY_CODE,
  currencySymbol?: boolean,
): string {
  try {
    if (currencySymbol === false) {
      const currencyNoSymbol = Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
      })
        .formatToParts(amount)
        .filter(p => p.type !== 'currency')
        .map(p => p.value)
        .join('');
      return currencyNoSymbol;
    }
    const formatter = Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
    }).format;
    return formatter(amount);
  } catch (err) {
    const formatter = Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode })
      .format;
    return formatter(amount);
  }
}

export function convertUnitPriceCurrency(
  amount: number,
  currencyCode: string = LOCAL_ISO_CURRENCY_CODE,
  quantity: number = 1,
  unitOfMeasure: string = UnitOfMeasureTypes.Each,
): string {
  const formattedPrice = convertCurrency(amount, currencyCode);
  return `${formattedPrice} /${quantity > 1 ? ` ${quantity | 0}` : ''} ${unitOfMeasure}`;
}
